import React, { useEffect, useState, useContext, useRef } from "react";
import { RiChatSmileFill } from "react-icons/ri";
import { Doughnut } from 'react-chartjs-2';
import { Bar, Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import ModalComponent from "../pick_modal";
import axios from "axios";
import { BASELINE } from "../../../util";
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const DigitalActView = ({ user, setdashboard }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [topic, settopic] = useState(false);
    const [section, setsection] = useState("");
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [scores, setScores] = useState({ english: 0, math: 0, reading: 0, science: 0 });
    const [allscores, setallScores] = useState([]);
    const [topMissedTopics, setTopMissedTopics] = useState([]);
    const [activeSubject, setActiveSubject] = useState('english');

    const [topics, settopics] = useState([
        { topic: '["IES"]', full: "Intergrating Essential Skills" },
        { topic: '["A"]', full: "Statistics and Probability" },
        { topic: '["F"]', full: "Algebra" },
        { topic: '["G"]', full: "Geometry" },
        { topic: '["F"]', full: "Functions" },
        { topic: '["N"]', full: "Number and Quantity" },
        { topic: '["T"]', full: "Trigonometry" },
        { topic: '["S"]', full: "Statistics and Probability" }
    ]);

    const handleRowClick = (subjectName, section) => {
        const matchedTopic = topics.find(t => t.full === subjectName);

        if (matchedTopic) {
            setsection("ACT"); // Assuming setSection is correctly defined
            settopic(matchedTopic.topic); // Set the 'topic' state to the matched 'topic' value
            setIsModalOpen2(true); // Open the modal
        }
    };


    const getChartDataForSubject = (subject) => {
        const labels = allscores.map((_, index) => `Test ${index + 1}`);
        const data = allscores.map(score => score[subject]);

        return {
            labels,
            datasets: [{
                label: `${subject.charAt(0).toUpperCase() + subject.slice(1)} Scores`,
                data,
                fill: false,
                borderColor: 'rgba(59, 130, 246, 1)', // Changed to blue
                backgroundColor: 'rgba(59, 130, 246, 0.2)', // Light blue background
                tension: 0.1
            }]
        };
    };

    // Use this function in your Line chart:
    const lineChartData = getChartDataForSubject(activeSubject);

    const subjects = ['English', 'Math', 'Reading', 'Science'];
    const getChartData = (score) => ({
        labels: ['Score', 'Remaining'],
        datasets: [
            {
                data: score ? [score, 36 - score] : [0, 36],
                backgroundColor: ['#3B82F6', '#1E293B'], // Changed to blue and dark blue
                borderWidth: 0,
            },
        ],
    });

    const countTopicsAndFindTopTen = (incorrectQuestionIds) => {
        const topicCounts = {};
        // Count each topic occurrence, filtering out null or undefined topics
        incorrectQuestionIds.forEach(question => {
            const topic = question.category;
            if (topic !== null && topic !== undefined && question.section === "math" && question.section_data !== null) {
                if (topicCounts[topic]) {
                    topicCounts[topic]++;
                } else {
                    topicCounts[topic] = 1;
                }
            }
        });

        // Convert the topicCounts object into an array and sort by count
        const sortedTopics = Object.entries(topicCounts).sort((a, b) => b[1] - a[1]);

        // Select the top 10 most frequent topics
        return sortedTopics.slice(0, 10).map(entry => {
            const topicAbbr = entry[0];
            const topicFull = topics.find(t => t.topic === topicAbbr)?.full || topicAbbr;
            return {
                topic: topicFull,
                count: entry[1]
            }
        });
    };

    const getChartData2 = (subjectIndex) => {
        const score = calculateAverageBySubject(subjectIndex);
        return {
            labels: ['Score', 'Remaining'],
            datasets: [
                {
                    data: [score, 36 - score],  // Calculate the remaining score
                    backgroundColor: ['#3B82F6', '#1E293B'],  // Changed to blue and dark blue
                    borderWidth: 0,
                },
            ],
        };
    };


    const calculateAverageBySubject = (subject) => {
        const total = allscores.reduce((acc, scores) => {
            return {
                english: acc.english + scores.english,
                math: acc.math + scores.math,
                reading: acc.reading + scores.reading,
                science: acc.science + scores.science
            };
        }, { english: 0, math: 0, reading: 0, science: 0 });

        const numberOfEntries = allscores.length;

        const averages = {
            english: total.english / numberOfEntries,
            math: total.math / numberOfEntries,
            reading: total.reading / numberOfEntries,
            science: total.science / numberOfEntries
        };

        // Map numbers to subjects
        const subjectMap = {
            1: 'english',
            2: 'math',
            3: 'reading',
            4: 'science'
        };

        // Return the average for the selected subject
        // Default to 0 if subject number is invalid
        return averages[subjectMap[subject]] || 0;
    };


    const addNewScoreSet = (newScoreSet) => {
        setallScores(prevScores => [
            ...prevScores,
            {
                english: newScoreSet.english || 0,
                math: newScoreSet.math || 0,
                reading: newScoreSet.reading || 0,
                science: newScoreSet.science || 0
            }
        ]);
    };

    const latest_ACT = () => {
        axios.get(`${BASELINE}get/act/scores`, { params: { u_id: user.u_id } })
            .then(function (response) {
                let allIncorrectQuestions = [];

                response.data.forEach(entry => {

                    // Ensure `eng_score` exists and is not null
                    if (entry.eng_score !== null) {
                        try {
                            const data = JSON.parse(entry.eng_score);  // Parse the `eng_score` safely

                            // Add each new score set to the historical list
                            addNewScoreSet({
                                english: data.english || 0,  // Safely handle missing values
                                math: data.math || 0,
                                reading: data.reading || 0,
                                science: data.science || 0
                            });
                        } catch (err) {
                            console.error("Error parsing eng_score:", err.message);
                        }
                    }

                    if (entry.Incorrect_questionIds) {
                        allIncorrectQuestions.push(...JSON.parse(entry.Incorrect_questionIds));
                    }
                });

                // Process the latest score (with section_data check)
                if (response.data && response.data.length > 0) {
                    const latestEntry = response.data[response.data.length - 1];

                    // Check if section_data is present and not empty for the latest entry
                    if (latestEntry.section_data) {
                        const sectionData = JSON.parse(latestEntry.section_data);
                    }

                    if (latestEntry.eng_score) {
                        const data = JSON.parse(latestEntry.eng_score);
                        setScores({
                            english: data.english || 0,
                            math: data.math || 0,
                            reading: data.reading || 0,
                            science: data.science || 0
                        });
                    }

                    const topMissedTopics = countTopicsAndFindTopTen(allIncorrectQuestions);

                    const filteredTopics = topMissedTopics.filter(topicObj => !topicObj.topic.includes('['));

                    setTopMissedTopics(filteredTopics);
                } else {
                    console.error("Received empty or invalid data:", response.data);
                }
            })
            .catch(function (error) {
                console.error("Error fetching ACT scores:", error);
                alert("Something went wrong while fetching ACT scores.");
            });
    };

    useEffect(() => {
        latest_ACT();
    }, [user]); // Call when `user` changes


    const handleClose = () => {
        setIsVisible(false);
    };

    function findTopMissedTopics(data, tag) {
        const topicCount = {};

        // Count incorrect topics for the specified tag
        data.forEach(item => {
            if (item.tag === tag && !item.correct) {
                topicCount[item.topic] = (topicCount[item.topic] || 0) + 1;
            }
        });

        // Convert the topicCount object into an array of [topic, count] pairs
        const sortedTopics = Object.entries(topicCount).sort((a, b) => b[1] - a[1]);

        // Select the top 10
        return sortedTopics.slice(0, 10).map(entry => ({ topic: entry[0], count: entry[1] }));
    }

    const options3 = {
        scales: {
            y: {
                beginAtZero: false,  // Change this as needed
                suggestedMax: 36,  // Assuming SAT scores are out of 1600
                grid: {
                    color: 'rgba(255, 255, 255, 0.1)'  // Lighter grid lines
                },
                ticks: {
                    color: '#94A3B8'  // Light blue-gray text
                }
            },
            x: {
                grid: {
                    color: 'rgba(255, 255, 255, 0.1)'  // Lighter grid lines
                },
                ticks: {
                    color: '#94A3B8'  // Light blue-gray text
                }
            }
        },
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    color: '#E2E8F0'  // Light blue-gray text for legend
                }
            }
        },
        // Making sure chart is responsive
        responsive: true
    };


    return (
        <div className="text-gray-100">
            <ModalComponent topic={topic} isOpen={isModalOpen2} onClose={setIsModalOpen2} section={section} />
            <div className="p-4 md:p-6 flex flex-col items-center">
                <div className="w-full max-w-[100%]">
                    <h1 className="text-xl md:text-2xl font-bold mt-2 md:mt-4 text-white">Digital ACT View</h1>
                </div>
            </div>

            <div className="px-4 md:px-6">
                <div className="bg-gray-900 bg-opacity-30 text-white p-4 md:p-6 rounded-lg shadow-md flex flex-col border-l-4 border-blue-500">
                    <div className="flex items-center mb-4 md:mb-6">
                        <div className="bg-blue-500 h-8 w-1 mr-3"></div>
                        <span className="text-lg md:text-xl font-medium">Your Latest ACT Score</span>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-4">
                        {subjects.map((subject, index) => {
                            return (
                                <div key={index} className="p-4 bg-gray-800 rounded-lg transition-all duration-200 hover:translate-y-[-4px] hover:shadow-lg">
                                    <div className="flex items-center justify-between mb-3">
                                        <h3 className="font-medium text-gray-300">{subject}</h3>
                                    </div>
                                    <div className="flex items-center">
                                        <div className="w-12 h-12 md:w-16 md:h-16 mr-3">
                                            <Doughnut
                                                data={getChartData(scores[subject.toLowerCase()])}
                                                options={{
                                                    cutout: '75%',
                                                    plugins: {
                                                        tooltip: { enabled: false },
                                                        legend: { display: false },
                                                    },
                                                    responsive: true,
                                                    maintainAspectRatio: true
                                                }}
                                            />
                                        </div>
                                        <div className="flex flex-col">
                                            <span className="text-xl md:text-2xl font-bold text-white">{scores[subject.toLowerCase()]}</span>
                                            <span className="text-xs text-gray-400">out of 36</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className="mt-4 md:mt-6 px-4 md:px-6 flex flex-col items-center">
                {/* First Row of Charts */}
                <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" style={{ maxHeight: '100%' }}>
                    {subjects.map((subject, index) => (
                        <div key={index} className="relative bg-black bg-opacity-70 p-4 md:p-5 rounded-lg shadow-lg border border-blue-900 backdrop-blur-sm overflow-hidden group">
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 opacity-10 group-hover:opacity-20 transition-opacity duration-300"></div>
                            <div className="absolute -right-20 -bottom-20 w-40 h-40 rounded-full bg-blue-500 opacity-10 blur-2xl"></div>
                            <div className="absolute -left-20 -top-20 w-40 h-40 rounded-full bg-indigo-500 opacity-10 blur-2xl"></div>
                            <div className="relative">
                                <h2 className="text-base md:text-lg font-semibold mb-2 text-blue-300">Average {subject} Score</h2>
                                <div style={{ height: '140px' }} className="md:h-[180px]">
                                    <Doughnut
                                        data={getChartData2(index + 1)}  // Plus 1 because subjects array is 0-based and subjectMap is 1-based
                                        options={{
                                            maintainAspectRatio: false,
                                            aspectRatio: 1,
                                            responsive: true
                                        }}
                                    />
                                </div>
                                <div className="text-center mt-2">
                                    <span className="text-xl md:text-2xl font-bold text-white">
                                        {calculateAverageBySubject(index + 1).toFixed(1)} / 36
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mt-4 md:mt-6 px-4 md:px-6 flex flex-col items-center">
                <div className="w-full">
                    <div className="p-4 md:p-6 bg-black bg-opacity-20 text-white shadow-xl rounded-lg border border-blue-900 flex flex-col justify-between backdrop-blur-sm relative overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-indigo-800 opacity-20"></div>
                        <div className="absolute -right-20 top-10 w-60 h-60 rounded-full bg-blue-500 opacity-10 blur-3xl"></div>
                        <div className="relative z-10">
                            <div className="flex items-center mb-4">
                                <span className="bg-blue-900 bg-opacity-80 text-blue-200 text-xs md:text-sm font-semibold mr-2 px-2 py-0.5 rounded border border-blue-600">Digital ACT</span>
                                <span className="text-lg md:text-xl font-bold">Recommended Missing Math Topics</span>
                            </div>
                            <div className="flex-7 p-3 md:p-4 rounded-lg bg-black bg-opacity-50 overflow-auto border-l-2 border-blue-500" style={{ maxHeight: '240px', overflowY: 'auto' }}>
                                <ul className="list-none pl-1 md:pl-2">
                                    {topMissedTopics.map((topic, index) => (
                                        <li key={index}
                                            className="mb-2 text-base md:text-xl cursor-pointer hover:bg-blue-900 hover:bg-opacity-30 p-2 rounded-md transition-all duration-200 flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-blue-900 border-opacity-30"
                                            onClick={() => handleRowClick(topic.topic, "English")}
                                        >
                                            <span className="mb-1 sm:mb-0 break-words">{topic.topic}</span> 
                                            <span className="text-blue-300 font-semibold px-3 py-1 bg-blue-900 bg-opacity-30 rounded-full">{topic.count}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative p-4 md:p-6 bg-black bg-opacity-20 mx-4 md:mx-6 shadow-xl rounded-lg mt-4 md:mt-6 border border-blue-900 backdrop-blur-sm overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-800 opacity-10"></div>
                <div className="absolute -left-20 -bottom-20 w-80 h-80 rounded-full bg-blue-600 opacity-10 blur-3xl"></div>
                <div className="absolute right-20 top-10 w-40 h-40 rounded-full bg-indigo-600 opacity-10 blur-2xl"></div>

                <div className="relative z-10">
                    <h2 className="text-base md:text-lg font-semibold mb-4 text-white border-l-4 border-blue-500 pl-3">Overall ACT Scores</h2>

                    {/* Tabs for selecting the subject */}
                    <div className="flex flex-wrap mb-4">
                        {subjects.map((subject, index) => (
                            <button
                                key={index}
                                onClick={() => setActiveSubject(subject.toLowerCase())}
                                className={`py-1 md:py-2 px-2 md:px-6 text-xs md:text-sm font-medium rounded-t-lg transition-all duration-200 ${
                                    activeSubject === subject.toLowerCase() 
                                    ? 'bg-blue-900 bg-opacity-30 text-blue-300 shadow-lg shadow-blue-900/20' 
                                    : 'text-gray-400 hover:text-blue-200 hover:bg-blue-900 hover:bg-opacity-10'
                                }`}
                            >
                                {subject}
                            </button>
                        ))}
                    </div>

                    {/* Line Graph Display */}
                    <div className="flex flex-col justify-center items-center pt-2 md:pt-4 bg-black bg-opacity-30 rounded-lg p-2 md:p-4 border-l-2 border-blue-500">
                        <div className="w-full h-48 md:h-64 flex justify-center items-center">
                            <Line data={lineChartData} options={options3} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DigitalActView;